import {
    SimpleGrid,
} from "@chakra-ui/react";

import {
    Wallet,
    Landmark,
    Users,
} from "lucide-react";

import {
    useSelector,
} from "react-redux";

import StatCard from "../../Dashboard/components/StatCard";
import ProgressCard from "../../Dashboard/components/ProgressCard";

const CommissionStats =
    ({
    payouts = [],
}) => {
        const {
    referredDrivers = [],
} = useSelector(
    state =>
        state.driverPartner
);

        const pendingAmount =
            payouts
                .filter(
                    (
                        payout
                    ) =>
                        payout.status ===
                        "Pending"
                )
                .reduce(
                    (
                        total,
                        payout
                    ) =>
                        total +
                        Number(
                            payout.amount
                        ),
                    0
                );

        const totalCommissions =
            payouts.reduce(
                (
                    total,
                    payout
                ) =>
                    total +
                    Number(
                        payout.amount
                    ),
                0
            );

        const paidCommissions =
            payouts.filter(
                (
                    payout
                ) =>
                    payout.status ===
                    "Paid"
            ).length;

        const activeDrivers =
            referredDrivers.filter(
                driver =>
                    driver.driver
                        ?.status ===
                    "Approved"
            ).length;

        return (
            <SimpleGrid
                columns={{
                    base: 1,
                    lg: 3,
                }}
                gap={6}
                mb={8}
            >
                <StatCard
                    title="Pending Payouts"
                    value={`P${pendingAmount.toFixed(
                        2
                    )}`}
                    subtitle={`${paidCommissions} commissions processed`}
                    icon={
                        <Landmark
                            size={
                                20
                            }
                            color="#DC2626"
                        />
                    }
                />

                <StatCard
                    title="Total Commissions"
                    value={`P${totalCommissions.toFixed(
                        2
                    )}`}
                    subtitle="All time earnings"
                    icon={
                        <Wallet
                            size={
                                20
                            }
                            color="#2453FF"
                        />
                    }
                />

                <ProgressCard
                    title="Active Recruits"
                    percentage={
                        referredDrivers.length >
                        0
                            ? (
                                  activeDrivers /
                                  referredDrivers.length
                              ) *
                              100
                            : 0
                    }
                    current={`${activeDrivers} Drivers`}
                    target={`${referredDrivers.length} Drivers`}
                />
            </SimpleGrid>
        );
    };

export default CommissionStats;